import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class ScheduledStreamContentsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'ScheduledStreamContentsStateModel';

    constructor() {
        super(ScheduledStreamContentsStateModel.identifier);
    }
}
